import React from 'react';
import PropTypes from 'prop-types';
import CommentEditor from '../CommentEditor';

/**
 * New Ticket CommentPlain (description) field component
 */
const CommentPlain = ({ name, onChange, value, error }) => (
  <CommentEditor
    name={name}
    onChange={onChange}
    classes="animated fadeIn"
    value={value}
    error={error}
    hideUpload
  />
);

CommentPlain.propTypes = {
  /** The form name and schema key */
  name: PropTypes.string.isRequired,
  /** Callback for change event */
  onChange: PropTypes.func.isRequired,
  /** The current field value */
  value: PropTypes.string.isRequired,
  /** The possible error of the field */
  error: PropTypes.string
};

export default CommentPlain;
